import { GenericObject } from '../../shared/types'
import { useObjectGetBatched } from '../api/object'

function getProposalVehicleInternalName(proposalVehicle?: GenericObject) {
	if (!proposalVehicle) return ''
	const knownValue =
		proposalVehicle.interni_nazev ??
		proposalVehicle.interni_nazev_vozidla ??
		proposalVehicle.internal_name ??
		proposalVehicle.internal_vehicle_name ??
		proposalVehicle.interniNazev ??
		proposalVehicle.internalName

	if (typeof knownValue === 'string' && knownValue.trim()) {
		return knownValue.trim()
	}

	for (const [key, value] of Object.entries(proposalVehicle)) {
		if (typeof value !== 'string') continue
		if (!/(intern|internal)/i.test(key)) continue
		if (!value.trim()) continue
		return value.trim()
	}

	return ''
}

export function getProposalVehicleLabelText(proposalVehicle?: GenericObject) {
	if (!proposalVehicle) return ''
	if (!proposalVehicle.license_plate) return proposalVehicle.name
	return `${proposalVehicle.name} (${proposalVehicle.license_plate})`
}

export function getProposalVehicleLabel(proposalVehicle?: GenericObject, showInternalName = false) {
	if (!proposalVehicle) return ''

	const internalName = showInternalName ? getProposalVehicleInternalName(proposalVehicle) : ''
	const baseLabel = !proposalVehicle.license_plate ? (
		proposalVehicle.name
	) : (
		<>
			{proposalVehicle.name}{' '}
			<span className="text-gray-600">({proposalVehicle.license_plate})</span>
		</>
	)

	if (!internalName) {
		return baseLabel
	}

	return (
		<>
			{baseLabel}
			<br />
			<span className="text-gray-600">({internalName})</span>
		</>
	)
}

export function ProposalVehicleFormatter({
	id,
	showInternalName = false,
}: {
	id?: string
	showInternalName?: boolean
}) {
	const { data: proposalVehicle } = useObjectGetBatched('proposal_vehicle', id)

	if (!id) return <em className="text-gray-400">nevyplněno</em>

	return <>{getProposalVehicleLabel(proposalVehicle, showInternalName)}</>
}
